<template>
	<div class="activity-hospital-sales">
		<div class="search-area">
			<div class="search-item">
				<span class="label">活动记录：</span>
				<el-select v-model="searchForm.ActivityCode" filterable remote reserve-keyword placeholder="请输入活动名称"
					:remote-method="remoteMethodActivity" :loading="loadingActivity" @change="handleActivityChange"
					size="small" clearable>
					<el-option v-for="item in activityOptions" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">医院：</span>
				<el-select v-model="searchForm.Hospital" filterable remote reserve-keyword placeholder="请输入医院名称"
					:remote-method="remoteMethodHospital" :loading="loadingHospital"
					:disabled="!searchForm.ActivityCode" size="small" clearable>
					<el-option v-for="item in hospitalOptions" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">重点产品：</span>
				<el-select v-model="searchForm.lstLevel3Code" multiple collapse-tags placeholder="请选择重点产品"
					:disabled="!searchForm.ActivityCode" size="small" clearable>
					<el-option v-for="item in level3Options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="button-group">
				<el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
			</div>
		</div>

		<div class="content-area">
			<el-spinner v-if="loadingChart" style="margin: 20px auto; display: block;"></el-spinner>
			<el-empty v-else-if="!chartData || !chartData.length" description="暂无数据"></el-empty>
			<div v-else class="chart-container" style="padding: 20px;">
				<div ref="chart" style="width: 100%; height: 600px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		GetActivityHospitalSalesByTendency
	} from '@/api/newsapi';
	import {
		ActivityRecordList
	} from '@/api/ActivityRecord';
	import {
		HospitalList
	} from '@/api/home';
	import {
		HelperLEVEL3ForItem
	} from '@/api/ActivityList';

	export default {
		name: 'ActivityHospitalSalesByTendency',
		data() {
			return {
				searchForm: {
					ActivityCode: '',
					Hospital: '',
					lstLevel3Code: []
				},
				activityOptions: [],
				hospitalOptions: [],
				level3Options: [],
				loadingActivity: false,
				loadingHospital: false,
				loadingChart: false,
				chartData: [],
				myChart: null
			};
		},
		methods: {
			async remoteMethodActivity(query) {
				if (query !== '') {
					this.loadingActivity = true;
					try {
						let res = await ActivityRecordList({
							ActivityName: query,
							PageIndex: 1,
							PageSize: 20
						});
						if (res.code == 0) {
							this.activityOptions = res.data.data.map(item => ({
								value: item.ActivityCode,
								label: item.ActivityName
							}));
						}
					} finally {
						this.loadingActivity = false;
					}
				} else {
					this.activityOptions = [];
				}
			},
			handleActivityChange(val) {
				this.searchForm.Hospital = '';
				this.searchForm.lstLevel3Code = [];
				this.hospitalOptions = [];
				this.level3Options = [];
				if (val) {
					this.getLevel3Options(val);
				}
			},
			async remoteMethodHospital(query) {
				if (query !== '') {
					this.loadingHospital = true;
					try {
						let res = await HospitalList({
							hpName: query,
							ActivityCode: this.searchForm.ActivityCode
						});
						if (res.code == 0) {
							this.hospitalOptions = res.data.data.map(item => ({
								value: item.HPID,
								label: item.HPName
							}));
						}
					} finally {
						this.loadingHospital = false;
					}
				} else {
					this.hospitalOptions = [];
				}
			},
			async getLevel3Options(activityCode) {
				let res = await HelperLEVEL3ForItem({
					ActivityCode: activityCode
				});
				if (res.code == 0) {
					this.level3Options = res.data.map(item => ({
						value: item.Value,
						label: item.Text
					}));
				}
			},
			async handleSearch() {
				if (!this.searchForm.ActivityCode) {
					this.$message.warning('请选择活动记录');
					return;
				}
				this.loadingChart = true;
				try {
					let res = await GetActivityHospitalSalesByTendency(this.searchForm);
					if (res.code == 0) {
						this.chartData = res.data.tendencyReport;
					} else {
						this.chartData = [];
						this.$message.error(res.message);
					}
				} catch (e) {
					this.chartData = [];
					this.$message.error('获取数据失败');
				} finally {
					this.loadingChart = false;
					this.$nextTick(() => {
						this.drawChart();
					});
				}
			},
			drawChart() {
				const dom = this.$refs.chart;
				if (!dom) return;
				
				const data = this.chartData;
				if (!data || data.length === 0) return;

				let myChart = this.$MyEcharts.getInstanceByDom(dom);
				if (myChart) {
					myChart.dispose();
				}
				myChart = this.$MyEcharts.init(dom);
				this.myChart = myChart;

				const xAxisData = data.map(item => item.ReportDate);
				
				// 收集所有的 LEVEL3 名称，防止某一天没有数据导致 series 丢失
				const allLevel3 = new Set();
				data.forEach(d => {
					if (d.Items && d.Items.length > 0) {
						d.Items.forEach(item => {
							if (item.LEVEL3) {
								allLevel3.add(item.LEVEL3);
							}
						});
					}
				});
				
				const legendData = Array.from(allLevel3);
				const series = legendData.map(l3Name => {
					return {
						name: l3Name,
						type: 'line',
						smooth: true,
						data: data.map(d => {
							if (!d.Items) return 0;
							const match = d.Items.find(it => it.LEVEL3 === l3Name);
							return match ? match.Money : 0;
						})
					};
				});

				const option = {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: legendData,
						bottom: 10,
						type: 'scroll'
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: xAxisData
					},
					yAxis: {
						type: 'value',
						name: '销售金额'
					},
					series: series
				};

				myChart.setOption(option);
				window.addEventListener("resize", () => {
					myChart.resize();
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.activity-hospital-sales {
		/* padding: 20px; */
	}

	.search-area {
		background-color: #fff;
		padding: 20px;
		border-radius: 4px;
		margin-bottom: 20px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.search-item {
		margin-right: 15px;
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.label {
		margin-right: 10px;
		font-size: 14px;
		color: #606266;
		white-space: nowrap;
	}

	.button-group {
		margin-left: auto;
	}

	.content-area {
		min-height: 400px;
		background: #FFFFFF;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	/deep/ .el-input__inner,
	/deep/ .el-textarea__inner,
	/deep/ .el-select .el-input__inner,
	/deep/ .el-date-editor.el-input__inner {
		transition: all 0.8s;
		border-radius: 0px;
	}

	/deep/ .el-input__inner:focus,
	/deep/ .el-textarea__inner:focus,
	/deep/ .el-select.is-focus .el-input__inner,
	/deep/ .el-date-editor.is-focus .el-input__inner {
		border: 1px solid #e71d43 !important;
	}
</style>